import React, {useState} from 'react'
import { useForm } from 'react-hook-form';
import {
    Input,
    Button,
    Typography,
    IconButton,
    Spinner
} from "@material-tailwind/react";

//import { useAuth } from '../../hooks/useAuth';
import { useShared } from '../../hooks/useShared';
import AIcon from '../partials/AIcon';
import AInput from '../fields/AInput';
import SendResetPasswordLinkDialog from '../modals/SendResetPasswordLinkDialog';


const email= { label: 'Email', name: 'email', type: 'text', roles: [1], icon: 'person-outline', className: '', required: 'Email address is requieed', isStyle: true };
const password= { label: 'Password', name: 'password', type: 'password', roles: [1], icon: 'eye-outline', className: '', required: 'Password is requieed', isStyle: true };
export default function Login({}) {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const { auth } = useShared();
    const [sendResetPasswordLinkDialog , setSendResetPasswordLinkDialog ] = useState(false)
    return (
        <>
        <form className="mt-5 flex flex-col gap-4" onSubmit={handleSubmit((data,e)=>{e.preventDefault(); auth.login(data)})}>
            <div className='grid gap-6'>
              
                <AInput v={{data:email,register, errors, control}} />
                <AInput v={{data:password,register, errors, control}} />
            </div>

            { auth.errorMessage && <Typography
                variant="small"
                color="gray"
                className="mt-1 flex items-center text-red-500 gap-2 font-normal "
            >
                <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                { auth.errorMessage}
            </Typography>}
            <Button className="bg-main-color flex justify-center"  type="submit" disabled={ auth.loading}>  { auth.loading ? <Spinner color="teal" className="h-4 w-4" /> : "Login"}    </Button>
            <Typography
                variant="small"
                className="mt-2 flex items-center justify-center gap-2 font-normal opacity-60 cursor-pointer underline hover:text-blue-900 text-main-color font-bold "
                onClick={()=>setSendResetPasswordLinkDialog(true)}
            >
                <AIcon name="lock-closed" className="-mt-0.5 h-4 w-4" />
                Forgot Your Password?
            </Typography>

          
        </form>
        <SendResetPasswordLinkDialog v={{sendResetPasswordLinkDialog , setSendResetPasswordLinkDialog}} />
        </>
    )
}
